
import { Component, Prop, Vue } from 'vue-property-decorator'

import ProLabel from '~/components/common/freemium/ProLabel.vue'
import ChoiceIcon from '~/components/common/icon/ChoiceIcon.vue'
import Checkbox from '~/components/common/Checkbox.vue'

@Component({
  name: 'ScoreFilterBar',
  components: {
    ProLabel,
    ChoiceIcon,
    Checkbox
  }
})
export default class ScoreFilterBar extends Vue {
  @Prop({ type: String }) title!: string
  @Prop({ type: String }) description!: string
  @Prop({ type: Object, required: true }) filterSpec!: any
  @Prop({ type: Boolean, required: true }) isProFeature!: boolean
  @Prop({ type: String }) proReferer!: string
  @Prop({ required: true }) selectionOptions!: any
  @Prop({ required: true }) isPro!: boolean

  desk = [
    'ScholarshipOwl has no contact with these scholarship providers.',
    'Safe to apply, but award is not guaranteed by ScholarshipOwl.',
    'ScholarshipOwl has regular contact and history with these providers.',
    'Extremely safe. Scholarship award guaranteed by ScholarshipOwl.'
  ]
}
